// extracted by mini-css-extract-plugin
export default {"scroll_parent":"Scroll_scroll_parent__9B4P3","scroll_child":"Scroll_scroll_child__15EmA"};